import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { onlyUpdateForKeys } from '../../../../../node_module_clones/recompose';

// Components
import PwaOnly from '../../../../pwaApp/PwaOnly';

import TooltipSource from '../../../../components/tooltips/TooltipSource';
import Icon from '../../../../components/icons/Icon';

import AccountPopup from './AccountPopup';
import BillingAlertPopup from './BillingAlertPopup';

import ElectronAppUpdateNotify from './electronApp/ElectronAppUpdateNotify';
import ElectronAppUpdateRequiredPopup from './electronApp/ElectronAppUpdateRequiredPopup';
import PopupTrigger from '../../../../components/popupPanel/PopupTrigger';
import PwaAppVersionPoll from './pwa/PwaAppVersionPoll';
import PwaUpdateNotify from './pwa/PwaUpdateNotify';
import DarkModeSuggestionPopup from './darkModeSuggestion/DarkModeSuggestionPopup';

// Actions
import { navigateToLogin } from '../../../../reducers/navigationActions';

// Constants
import { PopupIds, PopupSections } from '../../../../components/popupPanel/popupConstants';

// Selectors
import { getCurrentUser } from '../../../../user/currentUserSelector';

// Styles
import './AccountUtil.scss';
import { getIsElectronSelector } from '../../../../components/electron/electronSelector';

const enhance = onlyUpdateForKeys(['currentUser', 'tooltipEnabled']);

const AccountUtil = (props) => {
    const { tooltipEnabled, isMobileView } = props;

    const dispatch = useDispatch();

    const login = () => dispatch(navigateToLogin());

    const currentUser = useSelector(getCurrentUser);

    const isElectronApp = useSelector(getIsElectronSelector);

    return (
        <div className="HeaderUtil AccountUtil">
            <TooltipSource
                tooltipText="Settings"
                distance={0}
                offset={-4}
                enabled={tooltipEnabled}
                delay={700}
                triggerOnMouseEnter
            >
                <PopupTrigger
                    className="header-util-button"
                    popupId={PopupIds.USER}
                    closeSection={PopupSections.HEADER}
                >
                    {() => (
                        <div className="header-util-button-content">
                            <Icon name="nav-settings" />
                            <ElectronAppUpdateNotify />
                            <PwaOnly>
                                <PwaUpdateNotify />
                            </PwaOnly>
                        </div>
                    )}
                </PopupTrigger>
            </TooltipSource>
            {!isMobileView && <DarkModeSuggestionPopup />}
            {!isMobileView && !isElectronApp && <PwaAppVersionPoll />}
            {!isMobileView && <AccountPopup {...props} login={login} currentUser={currentUser} />}
            {!isMobileView && <BillingAlertPopup />}
            {!isMobileView && <ElectronAppUpdateRequiredPopup {...props} login={login} currentUser={currentUser} />}
        </div>
    );
};

AccountUtil.propTypes = {
    isMobileView: PropTypes.bool,
    tooltipEnabled: PropTypes.bool,
};

export default enhance(AccountUtil);
